import { render, staticRenderFns } from "./error-messages.vue?vue&type=template&id=106502ae&scoped=true&"
import script from "./error-messages.vue?vue&type=script&lang=js&"
export * from "./error-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106502ae",
  null
  
)

export default component.exports